import { Injectable } from '@angular/core';
import { RadGpAutocompleteOptions } from './rad-gp-autocomplete-options';

@Injectable({
	providedIn: 'root'
})
export class RadGpAutocompleteService {
	private defaultOptions: RadGpAutocompleteOptions = {};
	
	setOptions(options: RadGpAutocompleteOptions) {
		this.defaultOptions = { ...this.defaultOptions, ...options };
	}

	getOptions(): RadGpAutocompleteOptions {
		return this.defaultOptions;
	}
}
